import React, { useState } from "react";
import __ from "lodash";
import Alert from "../../../controls/Alert";

const EditServicesValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";

  const checkServices = (services) => {
    let errors = [];

    if (services) {
      if (__.has(services, "inbound") && Array.isArray(services.inbound)) {
        for (let i = 0; i < services.inbound.length; i++) {
          const serviceRecord = services.inbound[i];
          if ((serviceRecord.isRequired || serviceRecord.isRequired === null && serviceRecord.requiredDefault === 1) && ! serviceRecord.serviceProviderUuid) {
            errors.push("All 'Inbound' service providers for services indicated as 'Required' must be specified");
          }
        }
      }
      if (__.has(services, "outbound") && Array.isArray(services.outbound)) {
        for (let i = 0; i < services.outbound.length; i++) {
          const serviceRecord = services.outbound[i];
          if ((serviceRecord.isRequired || serviceRecord.isRequired === null && serviceRecord.requiredDefault === 1) && ! serviceRecord.serviceProviderUuid) {
            errors.push("All 'Outbound' service providers for services indicated as 'Required' must be specified");
          }
        }
      }
    }

    return errors;
  }

  if (!error) {
    const serviceErrors = checkServices(record.services);
    if (serviceErrors && serviceErrors.length > 0) {
      error = true;
      errorMessage = serviceErrors[0];
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    // if (props.onChange) {
    //   props.onChange({ error, errorMessage, field });
    // }
  }

  return (
    <Alert open={error} severity="warning" message={errorMessage}/>
  );
}

export default EditServicesValidator;
